import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _StyledDivider, _StyledDivider2;
/* eslint-disable sort-keys */
import React, { useState, useLayoutEffect, useRef } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { useLocalization } from '@im/react-localization';
import { useNavTo } from '../../../nav';
import { AvatarPopover } from './AvatarPopover';
import ListItemIcon from '@mui/material/ListItemIcon';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Stack from '@mui/material/Stack';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function Avatar(props) {
  var avatarImg = props.avatarImg,
    _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    firstName = props.firstName,
    lastName = props.lastName,
    navItems = props.navItems,
    onLogoutClick = props.onLogoutClick,
    resellerID = props.resellerID,
    resellerProspect = props.resellerProspect,
    username = props.username;
  var theme = useTheme();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    openItems = _useState2[0],
    setOpenItems = _useState2[1];
  var showSubMenu = function showSubMenu(navItem, level, el) {
    var newOpenItems = _toConsumableArray(openItems);
    newOpenItems.length = level;
    if (navItem.navItems) {
      newOpenItems.push(navItem);
    }
    if (level === 0) setAnchorMenuEl(el);
    setOpenItems(newOpenItems);
    setTimeout(function () {
      setOpenItems(_toConsumableArray(newOpenItems));
    }, 1);
  };
  var _useLocalization = useLocalization(),
    translate = _useLocalization.translate;
  var navTo = useNavTo();
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    anchorMenuEl = _useState6[0],
    setAnchorMenuEl = _useState6[1];
  var actionRef = useRef(null);
  var open = Boolean(anchorEl);
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var handlePopoverClose = function handlePopoverClose() {
    setOpenItems([]);
    setAnchorMenuEl(null);
    setAnchorEl(null);
  };
  var getInitials = function getInitials() {
    var firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var lastName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };
  useLayoutEffect(function () {
    setTimeout(function () {
      var _actionRef$current;
      (_actionRef$current = actionRef.current) == null ? void 0 : _actionRef$current.updatePosition();
    }, 100);
  }, [open]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      "aria-controls": open ? 'account-menu' : undefined,
      "aria-expanded": open ? 'true' : undefined,
      "aria-haspopup": "true",
      "data-testid": "".concat(testid, "-avatarBtn"),
      onClick: function onClick(e) {
        return setAnchorEl(e.target);
      },
      sx: {
        padding: '0px'
      },
      "data-element": "IconButton",
      "data-source-file": "Avatar.tsx",
      children: avatarImg ? /*#__PURE__*/_jsx("img", {
        alt: "".concat(firstName, " ").concat(lastName, " avatar"),
        "data-testid": "".concat(testid, "-avatarImg"),
        height: "32px",
        src: avatarImg,
        width: "32px"
      }) : /*#__PURE__*/_jsx(InitialsCircle, {
        children: /*#__PURE__*/_jsx(Typography, {
          "data-testid": "".concat(testid, "-avatarInitials"),
          variant: "bodycopyregular",
          children: getInitials(firstName, lastName)
        })
      })
    }), /*#__PURE__*/_jsxs(Menu, {
      PaperProps: paperProps,
      action: actionRef,
      anchorEl: anchorEl,
      anchorOrigin: {
        horizontal: 'right',
        vertical: 'bottom'
      },
      id: "account-menu",
      marginThreshold: 16,
      onClose: handleClose,
      open: open,
      transformOrigin: {
        horizontal: 'right',
        vertical: 'top'
      },
      "data-element": "Menu",
      "data-source-file": "Avatar.tsx",
      children: [/*#__PURE__*/_jsxs(Stack, {
        direction: "column",
        "data-element": "Stack",
        "data-source-file": "Avatar.tsx",
        children: [/*#__PURE__*/_jsx(Typography, {
          sx: {
            pt: '8px'
          },
          variant: "smalltextregular",
          "data-element": "Typography",
          "data-source-file": "Avatar.tsx",
          children: translate('myprofile.ResellerId')
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "smalltextsemibold",
          "data-element": "Typography",
          "data-source-file": "Avatar.tsx",
          children: resellerID
        })]
      }), /*#__PURE__*/_jsxs(Stack, {
        direction: "column",
        "data-element": "Stack",
        "data-source-file": "Avatar.tsx",
        children: [/*#__PURE__*/_jsx(Typography, {
          sx: {
            pt: '8px'
          },
          variant: "smalltextregular",
          "data-element": "Typography",
          "data-source-file": "Avatar.tsx",
          children: translate('myprofile.UserName')
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "smalltextsemibold",
          "data-element": "Typography",
          "data-source-file": "Avatar.tsx",
          children: username
        })]
      }), !resellerProspect && /*#__PURE__*/_jsxs("div", {
        children: [_StyledDivider || (_StyledDivider = /*#__PURE__*/_jsx(StyledDivider, {})), /*#__PURE__*/_jsx(Typography, {
          sx: {
            pb: '8px'
          },
          variant: "h5regular",
          children: translate('Navigation.MyAccount')
        })]
      }), navItems && navItems.map(function (navItem) {
        return /*#__PURE__*/_jsxs(MenuItem, {
          onClick: function onClick(e) {
            if (!navItem.navItems) {
              handleClose();
              navTo(navItem);
            } else showSubMenu(navItem, 0, e.target);
          },
          sx: {
            minHeight: '32px !important',
            padding: '8px 12px'
          },
          children: [navItem.navItems && /*#__PURE__*/_jsx(ListItemIcon, {
            style: {
              minWidth: '15px'
            },
            children: /*#__PURE__*/_jsx(ArrowBackIosIcon, {
              sx: {
                height: '9px',
                width: '9px'
              }
            })
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "bodycopyregular",
            children: /*#__PURE__*/_jsx(ListItemText, {
              "data-testid": "".concat(navItem.key, "-MenuItem"),
              primary: navItem.label || translate(navItem.key)
            })
          })]
        }, navItem.key);
      }), /*#__PURE__*/_jsx(AvatarPopover, {
        anchorEl: anchorMenuEl,
        closePopover: handlePopoverClose,
        open: Boolean(openItems.length),
        openItems: openItems,
        showSubMenu: showSubMenu,
        "data-element": "AvatarPopover",
        "data-source-file": "Avatar.tsx"
      }), _StyledDivider2 || (_StyledDivider2 = /*#__PURE__*/_jsx(StyledDivider, {
        "data-element": "StyledDivider",
        "data-source-file": "Avatar.tsx"
      })), /*#__PURE__*/_jsx(Box, {
        "data-element": "Box",
        "data-source-file": "Avatar.tsx",
        children: /*#__PURE__*/_jsx(Button, {
          "aria-controls": open ? 'demo-customized-menu' : undefined,
          "aria-expanded": open ? 'true' : undefined,
          "aria-haspopup": "true",
          "data-testid": "logout",
          disableElevation: true,
          onClick: function onClick() {
            return onLogoutClick();
          },
          sx: {
            backgroundColor: theme.palette.primary[700],
            borderColor: theme.palette.primary[700],
            color: theme.palette.common.white,
            display: 'block',
            mx: 'auto',
            mt: '10px'
          },
          variant: "contained",
          "data-element": "Button",
          "data-source-file": "Avatar.tsx",
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "bodycopyregular",
            "data-element": "Typography",
            "data-source-file": "Avatar.tsx",
            children: translate('Navigation.LogOut')
          })
        })
      })]
    })]
  });
}
var InitialsCircle = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    alignItems: 'center',
    backgroundColor: theme.palette.primary[700],
    borderRadius: '100%',
    color: theme.palette.common.white,
    display: 'flex',
    height: '32px',
    justifyContent: 'center',
    width: '32px'
  };
});
var StyledDivider = styled(Divider)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    borderWidth: '0',
    borderBottom: "1px solid ".concat(theme.palette.grey[300]),
    marginTop: '8px'
  };
});
var paperProps = {
  elevation: 0,
  sx: {
    '& .MuiAvatar-root': {
      height: 90,
      ml: -0.5,
      mr: 1,
      width: 32
    },
    '& .MuiMenu-list': {
      minWidth: 156,
      padding: 0
    },
    '& .MuiMenuItem-root .MuiListItemText-root .MuiTypography-root': {
      color: '#333333',
      fontSize: 14,
      lineHeight: '22px',
      my: '-4px'
    },
    '&:before': {
      bgcolor: 'background.paper',
      content: '""',
      display: 'block',
      height: 18,
      position: 'absolute',
      right: 14,
      top: 2,
      transform: 'translateY(-60%) rotate(45deg)',
      width: 18,
      zIndex: 0
    },
    borderRadius: '4px',
    filter: 'drop-shadow(0px 2px 6px rgba(51, 51, 51, 0.15))',
    mt: 1.5,
    overflow: 'visible',
    padding: '16px'
  }
};